/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { EmptyResponse, EmptyResponse$inboundSchema } from "./emptyresponse.js";
import { Meta, Meta$inboundSchema } from "./meta.js";

export type V1DeploymentsStopDeploymentResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  /**
   * Empty response object by design. A successful response indicates this operation was successfully executed.
   */
  data: EmptyResponse;
};

/** @internal */
export const V1DeploymentsStopDeploymentResponseBody$inboundSchema: z.ZodType<
  V1DeploymentsStopDeploymentResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: EmptyResponse$inboundSchema,
});

export function v1DeploymentsStopDeploymentResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  V1DeploymentsStopDeploymentResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      V1DeploymentsStopDeploymentResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'V1DeploymentsStopDeploymentResponseBody' from JSON`,
  );
}
